import Comments from './Comments.styled';

export default Comments;
